/* bb-col-more (col package, 2026-10-12; fix pass same day)
   Lighter infinite scroll for collection grids (PRF-01). The old loaders
   fetched the WHOLE next page (about 125 KB compressed, 1.9 MB raw) and
   inserted it when the end of the grid was already on screen, so the page
   jumped (0.44 layout shift per batch on phones).

   - The next batch is fetched as ONE SECTION (Section Rendering API:
     ?page=N+1&section_id=...), about 24 KB.
   - mode "auto" (default; Paul keeps infinite scroll): when the end of the
     grid comes within about 1,400 px of the screen, same-size placeholders go
     in first, while that spot is still off screen, and the real cards replace
     them when they arrive. Nothing the shopper is looking at moves. The "Show
     more" link stays hidden unless a load fails.
   - mode "button": a "Show more pieces" button; the batch is prefetched as the
     button nears the screen and appended on the tap.
   - Auto mode also keeps sold-out cards at the end of everything loaded so
     far: when a batch arrives, the sold-out cards that closed the earlier
     batches move after the new in-stock cards (only while still off screen).
   - The link is a real link to ?page=N+1 (works without JavaScript, and
     crawlers follow it). The status line updates, saved-piece hearts repaint,
     keyboard users who tap land on the first new card, and once every piece
     is showing (from page 1) the page links are dropped so the grid simply
     ends.
   - Back / refresh fix (2026-10-18): the address bar no longer changes to
     ?page=N as batches load. It did, so a shopper who opened a product and
     came Back (or refreshed, or shared the link) got only that one batch of
     24 with the earlier pieces missing. Now the address keeps the filters
     only, and how far the shopper got (batches loaded + scroll position) is
     kept for this tab in sessionStorage. On Back or refresh the same batches
     are loaded again in one go and the shopper lands where they were.
   - After a filter or sort change the page brings the shopper to the start of
     the new results when they were further down (otherwise the loader could
     sit above the screen and never fire). The section loads this file on
     every collection page, so it also works after a narrow filter is removed.
   Self-contained: one custom element, no dependencies, re-initializes on its
   own when the filters re-render the grid. */
(function () {
  'use strict';
  if (window.customElements && customElements.get('bb-col-more')) return;

  var AUTO_MARGIN = '0px 0px 1400px 0px';
  var PREFETCH_MARGIN = '0px 0px 900px 0px';

  function sectionUrl(href, sectionId) {
    var u = new URL(href, window.location.origin);
    u.searchParams.set('section_id', sectionId);
    return u.toString();
  }

  function isSold(el) {
    return !!(el.classList && (el.classList.contains('bb-card--soldout') || el.querySelector('.bb-card--soldout')));
  }

  // ---- How far the shopper got, per address, for this tab only ----
  var KEY = 'bb-col-more:';
  var MAX_RESTORE_PAGES = 20;
  var firstCheck = true;   // the Back / refresh restore runs once per page load
  var restoring = false;   // while restoring, new elements wait before auto-loading

  function storeKey() { return KEY + location.pathname + location.search; }
  var loadKey = storeKey(); // the address this page was loaded at (filters change it later)

  function readState() {
    try { var s = JSON.parse(sessionStorage.getItem(storeKey()) || 'null'); return s && s.p ? s : null; } catch (e) { return null; }
  }

  function writeState(patch) {
    try {
      var s = readState() || { p: 1, y: 0 };
      for (var k in patch) s[k] = patch[k];
      s.t = Date.now();
      sessionStorage.setItem(storeKey(), JSON.stringify(s));
    } catch (e) {}
  }

  function navType() {
    try { var n = performance.getEntriesByType('navigation')[0]; if (n) return n.type; } catch (e) {}
    try { if (performance.navigation) return ['navigate', 'reload', 'back_forward'][performance.navigation.type]; } catch (e) {}
    return 'navigate';
  }

  function cardHref(card) {
    var a = card.querySelector && card.querySelector('a[href*="/products/"]');
    return a ? a.getAttribute('href').split('?')[0] : null;
  }

  // The first card showing at the top of the screen, so Back lands on that same piece
  // even if the sold-out cards settled in a slightly different order.
  function topCard() {
    var m = document.querySelector('bb-col-more');
    var grid = m && m.dataset.grid ? document.querySelector(m.dataset.grid) : null;
    if (!grid) {
      var w = document.querySelector('[data-bb-col-more]');
      var c = w && w.parentElement;
      grid = c && (c.querySelector('[id^="product-grid--"]') || c.querySelector('[data-cc-grid]'));
    }
    if (!grid) grid = document.querySelector('[id^="product-grid--"], [data-cc-grid]');
    if (!grid) return null;
    var kids = grid.children;
    for (var i = 0; i < kids.length; i++) {
      var r = kids[i].getBoundingClientRect();
      if (r.height && r.bottom > 1) { var h = cardHref(kids[i]); return h ? { a: h, o: Math.round(r.top) } : null; }
    }
    return null;
  }

  // Keep the scroll position current while extra batches are showing.
  function saveScroll() {
    var el = document.querySelector('[data-bb-col-more]');
    if (!el) return;
    var s = readState();
    if (s && s.p > 1) {
      var t = topCard();
      writeState({ y: Math.round(window.scrollY || window.pageYOffset || 0), a: t ? t.a : null, o: t ? t.o : 0 });
    }
  }
  var scrollTimer = null;
  window.addEventListener('scroll', function () {
    if (scrollTimer || restoring) return;
    scrollTimer = setTimeout(function () { scrollTimer = null; saveScroll(); }, 250);
  }, { passive: true });
  window.addEventListener('pagehide', function () { if (!restoring) saveScroll(); });

  // After a filter, sort or filter removal swaps the grid (assets/facets.js), bring the shopper to the start of the
  // new results if they were further down. Otherwise, on desktop, a shopper who had scrolled and then ticked a filter
  // in the sticky sidebar stood below the new, shorter grid: the loader sat above the screen and never fired, so the
  // page stopped at 24.
  document.addEventListener('filters:rerendered', function () {
    var go = function () {
      var c = document.querySelector('[id^="ProductGridContainer--"]');
      if (!c) return;
      var w = c.closest('.collection__product-grid') || c;
      var top = w.getBoundingClientRect().top;
      if (top < 0) window.scrollTo(0, Math.max(0, Math.round(top + (window.scrollY || 0) - 90)));
    };
    if (window.requestAnimationFrame) requestAnimationFrame(go); else setTimeout(go, 0);
  });

  class BBColMore extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.link = this.querySelector('a');
      this.wrap = this.closest('[data-bb-col-more]');
      this.grid = document.querySelector(this.dataset.grid);
      if (!this.link || !this.grid || !window.fetch || !window.DOMParser) return;
      this.next = this.dataset.next;
      this.sectionId = this.dataset.section;
      this.auto = this.dataset.mode !== 'button' && ('IntersectionObserver' in window);
      this.pending = null;
      this.link.addEventListener('click', this.onClick.bind(this));
      var self = this;
      this.link.addEventListener('pointerdown', function () { self.prefetch(); }, { passive: true });
      this.link.addEventListener('focus', function () { self.prefetch(); });
      if (this.auto) this.classList.add('is-auto');

      // First element on a page load: came Back or refreshed after loading more? Load the same batches again.
      if (firstCheck) {
        firstCheck = false;
        var s = readState();
        var nav = navType();
        if (s && s.p > 1 && this.dataset.page === '1' && storeKey() === loadKey && (nav === 'back_forward' || nav === 'reload')) {
          this.restore(s);
          return;
        }
      }
      // A grid that starts again at batch 1 (fresh visit, new filter or sort): forget older progress for this address.
      if (!restoring && this.dataset.page === '1') { try { sessionStorage.removeItem(storeKey()); } catch (e) {} }
      if (!restoring) this.observe();
    }

    observe() {
      var self = this;
      if (this.io) this.io.disconnect();
      if (this.auto) {
        this.classList.add('is-auto');
        this.io = new IntersectionObserver(function (entries) {
          if (entries[0] && entries[0].isIntersecting) { self.io.disconnect(); self.autoLoad(); }
        }, { rootMargin: AUTO_MARGIN });
        this.io.observe(this);
      } else if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (entries) {
          if (entries[0] && entries[0].isIntersecting) { self.prefetch(); self.io.disconnect(); }
        }, { rootMargin: PREFETCH_MARGIN });
        this.io.observe(this);
      }
    }

    // Back / refresh: fetch batches 2..p together, add them in order, then return to the saved spot.
    restore(s) {
      var self = this;
      restoring = true;
      var keepAuto = null;
      try { keepAuto = history.scrollRestoration; history.scrollRestoration = 'manual'; } catch (e) {}
      var last = Math.min(s.p, MAX_RESTORE_PAGES);
      var urls = [];
      for (var n = 2; n <= last; n++) {
        var u = new URL(this.next, window.location.origin);
        u.searchParams.set('page', String(n));
        urls.push(sectionUrl(u.toString(), this.sectionId));
      }
      var docs = urls.map(function (url) {
        return fetch(url, { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
          .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
      });
      var done = function () {
        restoring = false;
        var cur = document.querySelector('bb-col-more');
        if (cur && cur.observe) cur.observe();
        var y = s.y || 0;
        if (s.a && self.grid) {
          var kids = self.grid.children;
          for (var i = 0; i < kids.length; i++) {
            if (cardHref(kids[i]) === s.a) { y = kids[i].getBoundingClientRect().top + (window.scrollY || 0) - (s.o || 0); break; }
          }
        }
        window.scrollTo(0, Math.max(0, Math.round(y)));
        try { if (keepAuto) history.scrollRestoration = keepAuto; } catch (e) {}
      };
      var chain = Promise.resolve();
      var moved = s.r || [];
      docs.forEach(function (p, i) {
        chain = chain.then(function () {
          return p.then(function (doc) {
            var cur = document.querySelector('bb-col-more');
            // Replay whether the sold-out cards moved for this batch last time, so the order matches.
            if (cur && cur.apply) cur.apply(doc, null, false, moved[i] === 1 ? 'move' : moved[i] === 0 ? 'keep' : null);
          });
        });
      });
      // On any failure keep what loaded; the shopper carries on scrolling from there.
      chain.then(done, done);
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
    }

    prefetch() {
      if (this.pending) return this.pending;
      var url = sectionUrl(this.next, this.sectionId);
      this.pending = fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
      this.pending.catch(function () {});
      return this.pending;
    }

    placeholders() {
      var items = this.grid.children;
      var last = items[items.length - 1];
      var h = last ? last.getBoundingClientRect().height : 0;
      var per = Math.min(24, Math.max(0, parseInt(this.dataset.total, 10) - parseInt(this.dataset.to, 10)));
      var tag = last ? last.tagName.toLowerCase() : 'div';
      var made = [];
      for (var i = 0; i < per; i++) {
        var el = document.createElement(tag === 'li' ? 'li' : 'div');
        el.className = (tag === 'li' ? 'grid__item ' : '') + 'bb-col-skel';
        el.setAttribute('aria-hidden', 'true');
        if (h) el.style.minHeight = Math.round(h) + 'px';
        this.grid.appendChild(el);
        made.push(el);
      }
      return made;
    }

    // Auto mode: reserve the space now (still off screen), then fill it.
    autoLoad() {
      if (this.busy) return;
      this.busy = true;
      var self = this;
      var skeletons = this.placeholders();
      this.prefetch().then(function (doc) {
        self.apply(doc, skeletons, false);
      }).catch(function () {
        // Network trouble: take the placeholders out and show the plain
        // "Show more pieces" link so the shopper can carry on with a tap.
        skeletons.forEach(function (s) { s.remove(); });
        self.pending = null;
        self.busy = false;
        self.auto = false;
        self.classList.remove('is-auto');
      });
    }

    onClick(event) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return;
      event.preventDefault();
      if (this.busy) return;
      this.busy = true;
      var keyboard = event.detail === 0;
      var self = this;
      var skeletons = null;
      var settled = false;
      var p = this.prefetch();
      // If the batch is not here within one frame, reserve its space now, inside the tap.
      var t = setTimeout(function () { if (!settled) { skeletons = self.placeholders(); self.link.setAttribute('aria-busy', 'true'); self.link.classList.add('is-loading'); } }, 0);
      p.then(function (doc) {
        settled = true; clearTimeout(t);
        self.apply(doc, skeletons, keyboard);
      }).catch(function () {
        settled = true; clearTimeout(t);
        // Network trouble: fall back to the plain page link.
        window.location.href = self.next;
      });
    }

    apply(doc, skeletons, keyboard, trail) {
      var newGrid = doc.querySelector(this.dataset.grid);
      var incoming = newGrid ? Array.prototype.slice.call(newGrid.children) : [];
      var firstNew = null;
      var frag = document.createDocumentFragment();
      var soldFrag = document.createDocumentFragment();
      // Auto mode: the sold-out cards that close the batches already loaded move to after this
      // batch's in-stock cards, so they keep sitting at the end of everything loaded so far
      // instead of every 24 cards. Only when they are still below the screen, so nothing the
      // shopper is looking at moves.
      var trailing = [];
      if (this.auto) {
        var kids = Array.prototype.filter.call(this.grid.children, function (k) { return !k.classList.contains('bb-col-skel') && k.tagName !== 'STYLE'; });
        for (var i = kids.length - 1; i >= 0; i--) {
          if (isSold(kids[i])) trailing.unshift(kids[i]); else break;
        }
        if (trail === 'keep') trailing = [];
        else if (trail !== 'move' && trailing.length && trailing[0].getBoundingClientRect().top < window.innerHeight + 40) trailing = [];
      }
      // The real cards size themselves; only the placeholders carry a min-height.
      incoming.forEach(function (node) {
        var el = document.importNode(node, true);
        if (!firstNew && el.tagName !== 'STYLE') firstNew = el;
        if (trailing.length && isSold(el)) soldFrag.appendChild(el); else frag.appendChild(el);
      });
      trailing.forEach(function (k) { frag.appendChild(k); });
      frag.appendChild(soldFrag);
      if (skeletons && skeletons.length) {
        skeletons[0].parentNode.insertBefore(frag, skeletons[0]);
        skeletons.forEach(function (s) { s.remove(); });
      } else {
        this.grid.appendChild(frag);
      }

      // Swap in the new status / link / page links block.
      var newWrap = doc.querySelector('[data-bb-col-more]');
      var status = this.wrap && this.wrap.querySelector('[data-bb-col-status]');
      var from = status ? parseInt(status.getAttribute('data-from') || '1', 10) : 1;
      var nextEl = newWrap ? newWrap.querySelector('bb-col-more') : null;
      var to = nextEl ? parseInt(nextEl.dataset.to, 10) : parseInt(this.dataset.total, 10);
      var total = parseInt(this.dataset.total, 10);
      var noun = total === 1 ? this.dataset.nounOne : this.dataset.noun;
      if (newWrap && this.wrap) {
        var imported = document.importNode(newWrap, true);
        var st = imported.querySelector('[data-bb-col-status]');
        if (st) {
          st.setAttribute('data-from', String(from));
          if (from <= 1) {
            st.textContent = 'Showing ' + to + ' of ' + total + ' ' + noun;
          } else {
            st.firstChild && (st.firstChild.textContent = 'Showing ' + from + ' to ' + to + ' of ' + total + ' ' + noun + '. ');
          }
        }
        // Everything is showing, starting from page 1: no page links needed, the grid just ends.
        if (!nextEl && from <= 1) {
          var pages = imported.querySelector('.bb-col-more__pages');
          if (pages) pages.remove();
        }
        this.wrap.parentNode.replaceChild(imported, this.wrap);
      } else if (this.wrap) {
        this.remove();
      }

      // The address keeps the filters only (no ?page=N); remember how many batches are showing instead.
      var loadedPage = parseInt(this.dataset.page, 10) + 1;
      if (!isNaN(loadedPage)) {
        var prev = readState();
        var r = (prev && prev.r) ? prev.r.slice(0, Math.max(0, loadedPage - 2)) : [];
        r[loadedPage - 2] = trailing.length ? 1 : 0;
        for (var ri = 0; ri < r.length; ri++) if (r[ri] !== 1 && r[ri] !== 0) r[ri] = 0;
        writeState({ p: loadedPage, r: r });
      }
      if (window.BBSaved && typeof window.BBSaved.repaint === 'function') window.BBSaved.repaint();
      document.dispatchEvent(new CustomEvent('bb:col-more:appended', { detail: { count: incoming.length } }));
      if (keyboard && firstNew) {
        var a = firstNew.querySelector('a.bb-card__link, a[href]');
        if (a) a.focus({ preventScroll: false });
      }
    }
  }

  customElements.define('bb-col-more', BBColMore);
})();
